import type { HeatmapCell } from '@/lib/types';

interface Props {
  weeks: HeatmapCell[][];
  cell?: number;
  gap?: number;
}

export default function Heatmap({ weeks, cell = 10, gap = 2 }: Props) {
  const width = weeks.length * (cell + gap) - gap;
  const height = 7 * (cell + gap) - gap;

  return (
    <div className="overflow-x-auto">
      <svg width={width} height={height} role="img" aria-label="365-day activity heatmap" className="min-w-full">
        {weeks.map((col, x) =>
          col.map((c, y) => (
            <rect
              key={`${x}-${y}`}
              x={x * (cell + gap)}
              y={y * (cell + gap)}
              width={cell}
              height={cell}
              rx="2"
              className={levelClass(c.level)}
            >
              <title>{c.date}: {c.count} commits</title>
            </rect>
          ))
        )}
      </svg>
    </div>
  );
}

function levelClass(level: number): string {
  switch (level) {
    case -1: return 'fill-transparent';
    case 0:  return 'fill-border/10';
    case 1:  return 'fill-accent-500/30';
    case 2:  return 'fill-accent-500/55';
    case 3:  return 'fill-accent-500/80';
    case 4:  return 'fill-accent-500';
    default: return 'fill-border/10';
  }
}
